/**
 * stayai-pdp.js — Stay AI PDP price sync
 *
 * Keeps the Add-to-Cart (ATC) button price in sync with the Stay subscription widget.
 * When the user changes variant or subscription option (one-time vs subscribe), this script
 * copies the displayed price from the Stay widget’s selected option into the ATC button’s
 * price block so the button always shows the correct price.
 *
 * Flow:
 * - Waits for the product form (product-form) and .stayai-widget to exist (MutationObserver).
 * - Binds to variant:changed (form) and stay-ai-subscription-changed (window).
 * - On each change, re-reads the widget’s selected price and updates the ATC button price.
 * - If the ATC button is disabled (e.g. sold out), the price is not updated.
 */
(function () {
  // reminder: Ensure the product_form_id in the Customizer's Buybox settings points to the correct product form.
  const FORM_SELECTOR = '.pdp-content form[id*="product-form-template"][is=\'product-form\']';
  const STAY_WIDGET_SELECTOR = '.stayai-widget';

  const ATC_SELECTOR = `${FORM_SELECTOR} button[type='submit']`;
  /** Selector for the price element inside each ATC button (including sticky atc btn)*/
  const ATC_PRICE_SELECTOR = 'price-block div[data-price]';

  // Selector for the selected purchase option price inside the Stay widget.
  const SELECTED_PRICE_SELECTOR =
    '.stayai-widget label.is-selected [data-stayai-subscription-price], ' +
    '.stayai-widget label.is-selected [data-stayai-onetime-price]';

  function elementReady(selector) {
    return new Promise((resolve) => {
      const el = document.querySelector(selector);
      if (el) {
        resolve(el);
        return;
      }
      const observer = new MutationObserver((_records, obs) => {
        const found = document.querySelector(selector);
        if (!found) return;
        obs.disconnect();
        resolve(found);
      });
      observer.observe(document.documentElement, { childList: true, subtree: true });
    });
  }

  class StayAiPdp {
    constructor() {
      this.form = null;
      this.atcButton = null;
    }

    init() {
      if (!this.form) return;

      this.updateATCBtnPrice();
      this.form.addEventListener('variant:changed', () => {
        this.onSelectionChanged();
      });

      // Custom event (used if ref-buy-box-extended.js or equivalent is loaded)
      window.addEventListener('stay-ai-subscription-changed', () => {
        this.onSelectionChanged();
      });
    }

    onSelectionChanged() {
      // Re-read widget state; do not rely on event payload.
      queueMicrotask(() => this.updateATCBtnPrice());
    }

    updateATCBtnPrice() {
      // get Stay widget's selected purchase option's price elm
      const selectedPriceElm = document.querySelector(SELECTED_PRICE_SELECTOR);

      if (!selectedPriceElm) return;

      const atcPrices = document.querySelectorAll(`  ${ATC_PRICE_SELECTOR}`);
      if (!atcPrices.length) return;

      atcPrices.forEach((atcPriceElm) => {
        // bundle marks sold-out submit buttons as disabled; skip those
        const atcButtonElm = atcPriceElm.closest("button[type='submit']");
        if (atcButtonElm?.hasAttribute('disabled')) return;

        atcPriceElm.innerHTML = selectedPriceElm.innerHTML;
      });
    }
  }

  const pdp = new StayAiPdp();

  // Wait for form and Stay widget to exist (MutationObserver), then register listeners
  function runInit() {
    Promise.all([
      elementReady(FORM_SELECTOR),
      elementReady(STAY_WIDGET_SELECTOR),
    ]).then(() => {
      pdp.form = document.querySelector(FORM_SELECTOR);
      pdp.atcButton = document.querySelector(ATC_SELECTOR);
      pdp.init();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runInit);
  } else {
    runInit();
  }
})();

